// import React, { useEffect, useRef, useState } from 'react';
// import Navbar from '../Components/Navbar'
// import icon from '../Assets/Button Icon Container.png'
// import img from '../Assets/image.png'
// import img2 from '../Assets/why.png'
// import icon2 from '../Assets/icon (3).png'
// import icon3 from '../Assets/icon (1).png'
// import icon4 from '../Assets/icon (4).png'
// import icon5 from '../Assets/icon (2).png'
// import service from '../Assets/seerv.png'
// import arrow from '../Assets/arrow.png'
// import img3 from '../Assets/pj1.png'
// import test from '../Assets/Ellipse 64.png'
// import Footer from '../Components/Footer'
// import en from '../Assets/emergency-fund-concept-vector-illustration_108061-1890 2.png'
// import AOS from 'aos';
// import 'aos/dist/aos.css';
// import { useNavigate } from 'react-router-dom';
// function Home() {
//   const navigate = useNavigate()
//   const ref1 = useRef();
//   const ref2 = useRef();
//   const ref3 = useRef();

//   const [count1, setCount1] = useState(0);
//   const [count2, setCount2] = useState(0);
//   const [count3, setCount3] = useState(0);

//   const intervalRefs = useRef([null, null, null]);

//   const startCounting = (target, setCount, index) => {
//     let current = 0;
//     setCount(0);
//     clearInterval(intervalRefs.current[index]);

//     const increment = target / (2000 / 20);
//     intervalRefs.current[index] = setInterval(() => {
//       current += increment;
//       if (current >= target) {
//         setCount(target);
//         clearInterval(intervalRefs.current[index]);
//       } else {
//         setCount(Math.ceil(current));
//       }
//     }, 20);
//   };

//   const observe = (ref, setCount, target, index) => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           startCounting(target, setCount, index);
//         } else {
//           clearInterval(intervalRefs.current[index]);
//           setCount(0);
//         }
//       },
//       { threshold: 0.5 }
//     );

//     if (ref.current) observer.observe(ref.current);
//   };

//   useEffect(() => {
//     observe(ref1, setCount1, 160, 0);
//     observe(ref2, setCount2, 85, 1);
//     observe(ref3, setCount3, 98, 2);
//   }, []);

//   useEffect(() => {
//     AOS.init({
//       duration: 1000, // animation duration
//       once: true,     // whether animation should happen only once - while scrolling down
//     });
//   }, []);

//   const [IsLoggedIn, setIsLoggedIn] = useState(false);

//   useEffect(() => {
//     const token = localStorage.getItem("userToken");
//     if (token) {
//       setIsLoggedIn(true);
//     } else {
//       setIsLoggedIn(false);
//     }
//   }, []);


//   return (
//     <>
//       <Navbar />
//       <div className='banner'>
//         <div className='banner-text' data-aos-duration="2000" data-aos="fade-down">
//           <h5>Building Dreams with the Right Professionals.</h5>
//         </div>
//         <h3 data-aos-duration="2000" data-aos="fade-down">Your Project Our Network</h3>
//         <p data-aos-duration="2000" data-aos="fade-down">Post your construction requirements and get connected with our network of Professionals.</p>
//         <div className='flex gap-8'>
//         <button
//           onClick={() => {
//             if (!IsLoggedIn) {
//               navigate('/ph-UserLogin');
//             } else {
//               navigate('/AddRequirement');
//             }
//           }} data-aos-duration="2000" data-aos="fade-down" className='banner-button'>Post Your Requirements <img src={icon} />
//           </button>
//         <button
//           onClick={() => {
//             if (!IsLoggedIn) {
//               navigate('/SelectProfessionalTypeSignUp');
//             }
//           }} data-aos-duration="2000" data-aos="fade-down" className='banner-button'>Join As Professionals <img src={icon} />
//         </button>
//         </div>
//       </div>
//       <div className='about-home'>
//         <div className='about-home-left container'>
//           <img src={img} data-aos-duration="2000" data-aos="fade-down" />
//         </div>
//         <div className='about-home-right'>
//           <h3 data-aos-duration="2000" data-aos="fade-down">Our Foundation is Built on Trust and Excellence.</h3>
//           <p data-aos-duration="2000" data-aos="fade-down">Our foundation is rooted in a commitment to trust and ensuring every project is completed with integrity and superior quality. We prioritize building strong relationships with our delivering.</p>
//           <div className='counts' data-aos-duration="2000" data-aos="fade-down">
//             <div ref={ref1}>
//               <h4>{count1}+</h4>
//               <h5>Project Completion</h5>
//             </div>
//             |
//             <div ref={ref2}>
//               <h4>{count2}%</h4>
//               <h5>Sustnaible Pratices </h5>
//             </div>
//             |
//             <div ref={ref3}>
//               <h4>{count3}%</h4>
//               <h5>Client Satisfaction</h5>
//             </div>
//           </div>

//           <button data-aos-duration="2000" data-aos="fade-down" className='banner-button'>Post Your Requirements <img src={icon} /></button>

//         </div>
//       </div>
//       <div className='whyus'>
//         <div className='whyus-heading'>
//           <div className='whyus-div'>
//             <p>WHY CHOOSE US</p>
//           </div>
//           <h3>Our Services Make Us the Best <br />Construction Agency</h3>

//         </div>
//         <br />
//         <br />
//         <br />
//         <div className='why-types'>
//           <div className='why-types-left'>
//             <div className='why-types-div'>
//               <div className='ty-icon'>
//                 <img src={icon2} />

//               </div>
//               <h4>Broad Network</h4>
//               <p>Transforming spaces with precision and creativity to enhance functionality and style.</p>
//             </div>
//             <br />
//             <br />
//             <div className='why-types-div'>
//               <div className='ty-icon'>
//                 <img src={icon2} />

//               </div>
//               <h4>Reliable Service</h4>
//               <p>Transforming spaces with precision and creativity to enhance functionality and style.</p>
//             </div>
//           </div>
//           <div className='why-types-center'>
//             <img src={img2} />
//           </div>
//           <div className='why-types-right'>
//             <div className='why-types-div'>
//               <div className='ty-icon'>
//                 <img src={icon3} />

//               </div>
//               <h4>Qualified Professionals</h4>
//               <p>Transforming spaces with precision and creativity to enhance functionality and style.</p>
//             </div>
//             <br />
//             <br />
//             <div className='why-types-div'>
//               <div className='ty-icon'>
//                 <img src={icon4} />

//               </div>
//               <h4>Certified Engineers</h4>
//               <p>Transforming spaces with precision and creativity to enhance functionality and style.</p>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className='howitworks'>
//         <div className='howitworks-div'>
//           <div className='whyus-heading'>
//             <div className='whyus-div'>
//               <p>PROCESS</p>
//             </div>
//             <h3>How Its Works</h3>
//             <br />
//             <br />


//           </div>
//           <div className='Post'>

//             <div className='Post-div'>
//               <h3>01</h3>
//               <p>Post Your Project Requirements</p>
//             </div>
//             <div className='line'></div>

//             <div className='Post-div'>
//               <h3>02</h3>
//               <p>Connect With Contractor & Suppliers</p>
//             </div>
//             <div className='line'></div>

//             <div className='Post-div'>
//               <h3>03</h3>
//               <p>Complete Your Project With Ease</p>
//             </div>

//           </div>
//         </div>
//       </div>
//       <div className='home-service'>
//         <div className='service-headinmg'>

//           <div className='whyus-div'>
//             <p>OUR SERVICES</p>
//           </div>

//           <h3>Service We Offer</h3>

//         </div>
//         <div className="service-scroll-wrapper">
//           <div className="service-boxs">
//             {[...Array(2)].map((_, i) => (
//               <React.Fragment key={i}>
//                 <div>

//                   <div className="service-box">
//                     <img className="service-box-img" src={service} />
//                     <img className="arrow" src={arrow} />
//                     <p>Contractor Supplier</p>
//                   </div>
//                 </div>

//                 <div>

//                   <div className="service-box">
//                     <img className="service-box-img" src={service} />
//                     <img className="arrow" src={arrow} />
//                     <p>Contractor Supplier</p>
//                   </div>
//                 </div>
//                 <div>

//                   <div className="service-box">
//                     <img className="service-box-img" src={service} />
//                     <img className="arrow" src={arrow} />
//                     <p>Contractor Supplier</p>
//                   </div>
//                 </div>
//                 <div>

//                   <div className="service-box">
//                     <img className="service-box-img" src={service} />
//                     <img className="arrow" src={arrow} />
//                     <p>Contractor Supplier</p>
//                   </div>
//                 </div>
//                 <div>

//                   <div className="service-box">
//                     <img className="service-box-img" src={service} />
//                     <img className="arrow" src={arrow} />
//                     <p>Contractor Supplier</p>
//                   </div>
//                 </div>
//               </React.Fragment>
//             ))}
//           </div>
//         </div>
//       </div>
//       <div className='projects'>
//         <div className='projects-div'>
//           <div className='whyus-heading'>
//             <div className='whyus-div'>
//               <p>PROJECTS</p>
//             </div>
//             <h3>We Finished Several Projects. Let’s Look Ahead.</h3>
//             <br />
//             <br />


//           </div>
//           <div className='project-cards'>
//             <div>

//               <div className='project-card'>

//                 <div className='project-card-text'>
//                   <div>

//                     <h3>Rising Tide</h3>
//                     <p>Canada</p>
//                   </div>
//                   <div>
//                     <img src={arrow} />
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div>

//               <div className='project-card'>

//                 <div className='project-card-text'>
//                   <div>

//                     <h3>Rising Tide</h3>
//                     <p>Canada</p>
//                   </div>
//                   <div>
//                     <img src={arrow} />
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div>

//               <div className='project-card'>

//                 <div className='project-card-text'>
//                   <div>

//                     <h3>Rising Tide</h3>
//                     <p>Canada</p>
//                   </div>
//                   <div>
//                     <img src={arrow} />
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div>

//               <div className='project-card'>

//                 <div className='project-card-text'>
//                   <div>

//                     <h3>Rising Tide</h3>
//                     <p>Canada</p>
//                   </div>
//                   <div>
//                     <img src={arrow} />
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div>

//               <div className='project-card'>

//                 <div className='project-card-text'>
//                   <div>

//                     <h3>Rising Tide</h3>
//                     <p>Canada</p>
//                   </div>
//                   <div>
//                     <img src={arrow} />
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div>

//               <div className='project-card'>

//                 <div className='project-card-text'>
//                   <div>

//                     <h3>Rising Tide</h3>
//                     <p>Canada</p>
//                   </div>
//                   <div>
//                     <img src={arrow} />
//                   </div>
//                 </div>
//               </div>
//             </div>

//           </div>
//         </div>
//       </div>
//       <div className='testimonials'>
//         <div className='whyus-heading'>
//           <div className='whyus-div'>
//             <p>TESTIMONIALS</p>
//           </div>
//           <h3>What Over Client Says</h3>
//           <br />
//           <br />


//         </div>
//         <div className='testimonials-scroll-wrapper'>
//           <div className='testimonials-boxs'>
//             {/* Original Set */}
//             {[...Array(4)].map((_, i) => (
//               <div key={`testimonial-${i}`}>
//                 <div className='testimonials-box'>
//                   <div className='names-div'>
//                     <img src={test} />
//                     <div className='names'>
//                       <h3>Michael Scott</h3>
//                       <h4>Home Seller, USA</h4>
//                     </div>
//                   </div>
//                   <h2>Efficient tenant screening and maintenance turn my property into hassle-free income.</h2>
//                   <br />
//                   <div className='starts'>
//                     {[...Array(5)].map((_, j) => (
//                       <i key={j} className="bi bi-star-fill"></i>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             ))}

//             {/* Duplicate Set for Infinite Loop */}
//             {[...Array(4)].map((_, i) => (
//               <div key={`testimonial-duplicate-${i}`}>
//                 <div className='testimonials-box'>
//                   <div className='names-div'>
//                     <img src={test} />
//                     <div className='names'>
//                       <h3>Michael Scott</h3>
//                       <h4>Home Seller, USA</h4>
//                     </div>
//                   </div>
//                   <h2>Efficient tenant screening and maintenance turn my property into hassle-free income.</h2>
//                   <br />
//                   <div className='starts'>
//                     {[...Array(5)].map((_, j) => (
//                       <i key={j} className="bi bi-star-fill"></i>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>


//       </div>
//       {/* <div className='emergency-fund'>
//     <h3>Emergency Fund</h3>
//     <p>Available to support homeowners in unforeseen situations lorg construction projects.</p>
//    <button className='banner-button'>Get Now <img src={icon}/></button>

//     </div> */}
//       <div className='en-fund-div'>

//         <div className='en-fund'>
//           <div className='en-fund-left'>
//             <h3>Emergency Fund</h3>
//             <p>Available to support homeowners in unforeseen situations lorg construction projects.</p>
//             <button className='banner-button'>Get Now <img src={icon} /></button>
//           </div>
//           <div className='en-fund-right'>
//             <img src={en} />
//           </div>
//         </div>
//       </div>

//       <Footer />
//     </>
//   )
// }

// export default Home


// import React, { useEffect, useRef, useState } from 'react';
// import Navbar from '../Components/Navbar'
// import Footer from '../Components/Footer'
// import img from '../Assets/Container.png'
// import iconArrow from '../Assets/Button Icon Container.png'
// import icon from '../Assets/Link.png'
// import icon2 from '../Assets/icon (3).png'
// import icon3 from '../Assets/icon (4).png'
// import icon4 from '../Assets/icon (1).png'
// import icon5 from '../Assets/icon (2).png'
// import arrow from '../Assets/arrow.png'
// import test from '../Assets/Ellipse 64.png'
// import en from '../Assets/emergency-fund-concept-vector-illustration_108061-1890 2.png'
// import AOS from 'aos';
// import 'aos/dist/aos.css';
// import why2 from '../Assets/Group 39544.png'
// import service from '../Assets/seerv.png'
// import { useNavigate } from 'react-router-dom';
// import Contractor from '../Assets/Contractor1.png'
// import material from '../Assets/material.png'
// import freelancer from '../Assets/freelancer.png'
// import labour from '../Assets/labour.png'
// import Home2 from '../Assets/Home2.jpg'
// import { apiGet } from '../API/Api_Url';
// import pj1 from '../Assets/pj1.png'
// import pj2 from '../Assets/pj2.png'
// import pj3 from '../Assets/pj3.png'
// import pj4 from '../Assets/pj4.png'

// function Home() {
//   const navigate = useNavigate();
//   const ref1 = useRef();
//   const ref2 = useRef();
//   const ref3 = useRef();

//   const [count1, setcount1] = useState(0);
//   const [count2, setcount2] = useState(0);
//   const [count3, setcount3] = useState(0);

//   const intervalrefs = useRef([null, null, null]);

//   const startcounting = (target, setcount, index) => {
//     let current = 0;
//     setcount(0);
//     clearInterval(intervalrefs.current[index]);

//     const increment = target / (2000 / 20);
//     intervalrefs.current[index] = setInterval(() => {
//       current += increment;
//       if (current >= target) {
//         setcount(target);
//         clearInterval(intervalrefs.current[index]);
//       } else {
//         setcount(Math.ceil(current));
//       }
//     }, 20);
//   };

//   const observe = (ref, setcount, target, index) => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           startcounting(target, setcount, index);
//         } else {
//           clearInterval(intervalrefs.current[index]);
//           setcount(0);
//         }
//       },
//       { threshold: 0.5 }
//     );

//     if (ref.current) observer.observe(ref.current);
//   };

//   useEffect(() => {
//     observe(ref1, setcount1, 160, 0);
//     observe(ref2, setcount2, 85, 1);
//     observe(ref3, setcount3, 98, 2);
//   }, []);

//   useEffect(() => {
//     AOS.init({
//       duration: 1000,
//       once: true,
//     });
//   }, []);


//   const [IsLoggedIn, setIsLoggedIn] = useState(false);

//   useEffect(() => {
//     const token = localStorage.getItem("userToken");
//     if (token) {
//       setIsLoggedIn(true);
//     } else {
//       setIsLoggedIn(false);
//     }
//   }, []);

//   const [AllTestimonial, setAllTestimonial] = useState([]);

//   const [IsUploading, setIsUploading] = useState(false);

//   const GetAllTestimonials = async () => {
//     try {
//       setIsUploading(true);
//       const response = await apiGet('api/admin/GetAllTestimonials');
//       setAllTestimonial(response?.data);
//       setIsUploading(false);
//     } catch (error) {
//       setIsUploading(false);
//       console.error('Error fetching data:', error);
//     }
//   }

//   useEffect(() => {
//     GetAllTestimonials()
//   }, []);

//   return (
//     <>
//       <Navbar />
//       <div className='project-banner'>
//         <div className='pj-div'>
//           <div className='pj-div-left'>
//             <h3>Your Project Our Network</h3>
//           </div>
//           <div className='pj-div-right'>
//             <p>Post your construction or renovation requirements and get connected with our network of Professionals.</p>
//             <div className="flex gap-4">
//               <button
//                 onClick={() => {
//                   if (!IsLoggedIn) {
//                     navigate('/ph-UserLogin');
//                   } else {
//                     navigate('/AddRequirement');
//                   }
//                 }}
//               >
//                 Post your requirement
//               </button>
//               <button
//                 onClick={() => {
//                   if (!IsLoggedIn) {
//                     navigate('/SelectProfessionalTypeSignUp');
//                   }
//                 }}
//               >
//                 Join As Professionals
//               </button>
//             </div>
//           </div>
//         </div>
//         <br />
//         <br />
//         <div className='pj-imgs'>
//           {/* <img className='pj-imgs-img' src={img} /> */}
//           <img className='pj-imgs-role' src={icon} />
//         </div>
//       </div>
//       <div className='about-home'>
//         <div className='about-home-left container'>
//           <img src={Home2} className='rounded-md' data-aos-duration="2000" data-aos="fade-down" />
//         </div>
//         <div className='about-home-right'>
//           <h3 data-aos-duration="2000" data-aos="fade-down">Our Foundation is Built on Trust and Excellence.</h3>
//           <p data-aos-duration="2000" data-aos="fade-down">Our foundation is rooted in a commitment to trust and ensuring every project is completed with integrity and superior quality. We prioritize building strong relationships with our delivering.</p>
//           <div className='counts' data-aos-duration="2000" data-aos="fade-down">
//             <div ref={ref1}>
//               <h4>{count1}+</h4>
//               <h5>Project Completion</h5>
//             </div>
//             |
//             <div ref={ref2}>
//               <h4>{count2}%</h4>
//               <h5>Sustnaible Pratices </h5>
//             </div>
//             |
//             <div ref={ref3}>
//               <h4>{count3}%</h4>
//               <h5>Client Satisfaction</h5>
//             </div>
//           </div>

//           <button data-aos-duration="2000" data-aos="fade-down"
//             className='banner-button'
//             onClick={() => {
//               if (!IsLoggedIn) {
//                 navigate('/ph-UserLogin');
//               } else {
//                 navigate('/AddRequirement');
//               }
//             }}
//           >Post Your Requirements <img src={iconArrow} /></button>
//         </div>
//       </div>
//       <div className='why2'>
//         <div className='why2-left'>
//           <img src={why2} />
//         </div>
//         <div className='why2-right'>
//           <p>Why Choose Us</p>
//           <h2>Make Your Projects More
//             Comfortable With <span>Our
//               Solutions</span></h2>
//           <div className='Broad'>
//             <img src={icon2} />
//             <div>
//               <h3>Broad Network</h3>
//               <h5>From initial consultation to project completion, we ensure
//                 every detail meets your highest standards.</h5>

//             </div>
//           </div>
//           <div className='Broad'>
//             <img src={icon3} />
//             <div>
//               <h3>Qualified Networks</h3>
//               <h5>From initial consultation to project completion, we ensure
//                 every detail meets your highest standards.</h5>

//             </div>
//           </div>
//           <div className='Broad'>
//             <img src={icon4} />
//             <div>
//               <h3>Reliable Service</h3>
//               <h5>From initial consultation to project completion, we ensure
//                 every detail meets your highest standards.</h5>

//             </div>
//           </div>
//           <div className='Broad'>
//             <img src={icon5} />
//             <div>
//               <h3>Certified Engineers</h3>
//               <h5>From initial consultation to project completion, we ensure
//                 every detail meets your highest standards.</h5>

//             </div>
//           </div>
//         </div>
//       </div>
//       <div className='how-works'>
//         <div className='about-us-heading'>
//           <p>Process</p>
//           <h3>How Its <span>Work</span></h3>
//         </div>
//         <br />
//         <br />
//         <div className='how-boxs'>
//           <div className='how-box'>
//             <h4>01</h4>
//             <h5>Post Your Project Requirements</h5>
//           </div>
//           <div className='line2'></div>
//           <div className='how-box'>
//             <h4>02</h4>
//             <h5>Connect With Contractor & Suppliers</h5>
//           </div>
//           <div className='line2'></div>

//           <div className='how-box'>
//             <h4>03</h4>
//             <h5>Complete Your Project With Ease</h5>
//           </div>
//         </div>
//       </div>
//       {/* <div className='v2-service'>
//         <div className='about-us-heading'>
//           <p>Services</p>
//           <h3>Services  <span>We Offer</span></h3>
//         </div>
//         <br />
//         <br />
//         <div className='service-boxv2s'>
//           <div>

//             <div className='service-boxv2'>
//               <div className='service-title'>
//                 <p>Contractor Supplier</p>
//               </div>

//             </div>
//           </div>

//           <div>

//             <div className='service-boxv2'>
//               <div className='service-title'>
//                 <p>Contractor Supplier</p>
//               </div>

//             </div>
//           </div>
//           <div>

//             <div className='service-boxv2'>
//               <div className='service-title'>
//                 <p>Contractor Supplier</p>
//               </div>

//             </div>
//           </div>
//         </div>
//       </div> */}
//       <div className='home-service'>
//         <div className='service-headinmg'>
//           <div className='whyus-div'>
//             <p>OUR SERVICES</p>
//           </div>

//           <h3>Service We Offer</h3>

//         </div>
//         <div className="service-scroll-wrapper">
//           <div className="service-boxs">
//             {[...Array(2)].map((_, i) => (
//               <React.Fragment key={i}>
//                 <div>
//                   <div className="service-box">
//                     <img className="service-box-img" src={Contractor} />
//                     <img className="arrow" src={arrow} />
//                     <p>Contractors</p>
//                   </div>
//                 </div>
//                 <div>
//                   <div className="service-box">
//                     <img className="service-box-img " src={material} />
//                     <img className="arrow" src={arrow} />
//                     <p>Material-Supplier</p>
//                   </div>
//                 </div>
//                 <div>
//                   <div className="service-box">
//                     <img className="service-box-img" src={freelancer} />
//                     <img className="arrow" src={arrow} />
//                     <p>Freelance Engineers</p>
//                   </div>
//                 </div>
//                 <div>
//                   <div className="service-box">
//                     <img className="service-box-img" src={labour} />
//                     <img className="arrow" src={arrow} />
//                     <p>Labours</p>
//                   </div>
//                 </div>
//                 <div>
//                   <div className="service-box">
//                     <img className="service-box-img" src={Contractor} />
//                     <img className="arrow" src={arrow} />
//                     <p>Contractors</p>
//                   </div>
//                 </div>
//                 <div>
//                   <div className="service-box">
//                     <img className="service-box-img" src={material} />
//                     <img className="arrow" src={arrow} />
//                     <p>Material-Supplier</p>
//                   </div>
//                 </div>
//                 <div>
//                   <div className="service-box">
//                     <img className="service-box-img" src={freelancer} />
//                     <img className="arrow" src={arrow} />
//                     <p>Freelance Engineers</p>
//                   </div>
//                 </div>
//                 <div>
//                   <div className="service-box">
//                     <img className="service-box-img" src={service} />
//                     <img className="arrow" src={arrow} />
//                     <p>Labours</p>
//                   </div>
//                 </div>
//               </React.Fragment>
//             ))}
//           </div>
//         </div>
//       </div>
//       {/* <div className='new-projects'>
//         <div className='new-projects-heading'>
//           <p>Recent Work</p>
//           <h3>Featured Projects</h3>
//         </div>
//         <br />
//         <br />
//         <br />
//         <div className='new-projects-boxs'>
//           <div>

//             <div className='new-projects-box'>
//               <div className='new-projects-box-title'>
//                 <h3>Rising Tide</h3>
//                 <p>Canada</p>
//               </div>
//             </div>
//           </div>

//           <div>

//             <div className='new-projects-box'>
//               <div className='new-projects-box-title'>
//                 <h3>Rising Tide</h3>
//                 <p>Canada</p>
//               </div>
//             </div>
//           </div>
//           <div>

//             <div className='new-projects-box'>
//               <div className='new-projects-box-title'>
//                 <h3>Rising Tide</h3>
//                 <p>Canada</p>
//               </div>
//             </div>
//           </div>
//           <div>

//             <div className='new-projects-box'>
//               <div className='new-projects-box-title'>
//                 <h3>Rising Tide</h3>
//                 <p>Canada</p>
//               </div>
//             </div>
//           </div>
//         </div>
//         <br />
//         <br />
//         <div
//           ref={sectionRef}
//           className='count-new'
//         >
//           <div className='count-new-box' style={{ textAlign: 'center' }}>
//             <h3 ref={count1}>0</h3>
//             <h4>Projects</h4>
//           </div>
//           <div className='count-new-box' style={{ textAlign: 'center' }}>
//             <h3 ref={count2}>0</h3>
//             <h4>Projects</h4>
//           </div>
//           <div className='count-new-box' style={{ textAlign: 'center' }}>
//             <h3 ref={count3}>0</h3>
//             <h4>Projects</h4>
//           </div>
//         </div>
//       </div> */}
//       <div className='projects'>
//         <div className='projects-div'>
//           <div className='whyus-heading'>
//             <div className='whyus-div'>
//               <p>PROJECTS</p>
//             </div>
//             <h3>We Finished Several Projects. Let’s Look Ahead.</h3>
//             <br />
//             <br />
//           </div>
//           <div className='project-cards'>
//             <div>
//               <div className='project-card'
//                 style={{ backgroundImage: `url(${pj1})` }}
//               >
//                 <div className='project-card-text'>
//                   <div>
//                     <h3>Rising Tide</h3>
//                     <p>Canada</p>
//                   </div>
//                   <div>
//                     <img src={arrow} />
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div>
//               <div className='project-card'
//               style={{ backgroundImage: `url(${pj2})` }}
//               >
//                 <div className='project-card-text'>
//                   <div>
//                     <h3>Rising Tide</h3>
//                     <p>Canada</p>
//                   </div>
//                   <div>
//                     <img src={arrow} />
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div>
//               <div className='project-card'
//               style={{ backgroundImage: `url(${pj3})` }}
//               >
//                 <div className='project-card-text'>
//                   <div>
//                     <h3>Rising Tide</h3>
//                     <p>Canada</p>
//                   </div>
//                   <div>
//                     <img src={arrow} />
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div>
//               <div className='project-card'
//               style={{ backgroundImage: `url(${pj4})` }}
//               >
//                 <div className='project-card-text'>
//                   <div>
//                     <h3>Rising Tide</h3>
//                     <p>Canada</p>
//                   </div>
//                   <div>
//                     <img src={arrow} />
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div>
//               <div className='project-card'
//               style={{ backgroundImage: `url(${pj1})` }}
//               >
//                 <div className='project-card-text'>
//                   <div>
//                     <h3>Rising Tide</h3>
//                     <p>Canada</p>
//                   </div>
//                   <div>
//                     <img src={arrow} />
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div>
//               <div className='project-card'
//               style={{ backgroundImage: `url(${pj2})` }}
//               >
//                 <div className='project-card-text'>
//                   <div>
//                     <h3>Rising Tide</h3>
//                     <p>Canada</p>
//                   </div>
//                   <div>
//                     <img src={arrow} />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className='testimonials'>
//         <div className='whyus-heading'>
//           <div className='whyus-div'>
//             <p>TESTIMONIALS</p>
//           </div>
//           <h3>What Over Client Says</h3>
//           <br />
//           <br />
//         </div>
//         {/* <div className='testimonials-scroll-wrapper'>
//           <div className='testimonials-boxs'>
//             {[...Array(4)].map((_, i) => (
//               <div key={`testimonial-${i}`}>
//                 <div className='testimonials-box'>
//                   <div className='names-div'>
//                     <img src={test} />
//                     <div className='names'>
//                       <h3>Michael Scott</h3>
//                       <h4>Home Seller, USA</h4>
//                     </div>
//                   </div>
//                   <h2>Efficient tenant screening and maintenance turn my property into hassle-free income.</h2>
//                   <br />
//                   <div className='starts'>
//                     {[...Array(5)].map((_, j) => (
//                       <i key={j} className="bi bi-star-fill"></i>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             ))}
//             {[...Array(4)].map((_, i) => (
//               <div key={`testimonial-duplicate-${i}`}>
//                 <div className='testimonials-box'>
//                   <div className='names-div'>
//                     <img src={test} />
//                     <div className='names'>
//                       <h3>Michael Scott</h3>
//                       <h4>Home Seller, USA</h4>
//                     </div>
//                   </div>
//                   <h2>Efficient tenant screening and maintenance turn my property into hassle-free income.</h2>
//                   <br />
//                   <div className='starts'>
//                     {[...Array(5)].map((_, j) => (
//                       <i key={j} className="bi bi-star-fill"></i>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div> */}
//         <div className='testimonials-scroll-wrapper'>
//           <div className='testimonials-boxs'>
//             {IsUploading ? (
//               <>
//                 <div className="flex justify-center items-center h-[200px]">
//                   <div className="w-24 h-24 border-8 border-gray-300 border-t-transparent rounded-full animate-spin"></div>
//                 </div>
//               </>
//             ) : (
//               AllTestimonial?.map((item, i) => (
//                 <div key={`testimonial-${i}`}>
//                   <div className='testimonials-box'>
//                     <div className='names-div'>
//                       <img className="w-20 h-20 rounded-full object-cover" src={item?.Image} />
//                       <div className='names'>
//                         <h3>{item?.Name}</h3>
//                         <h4>{item?.Adderss}</h4>
//                       </div>
//                     </div>
//                     <h2>{item?.Message}</h2>
//                     <br />
//                     <div className='starts'>
//                       {[...Array(item?.Rating)]?.map((_, j) => (
//                         <i key={j} className="bi bi-star-fill"></i>
//                       ))}
//                     </div>
//                   </div>
//                 </div>
//               )))}
//             {IsUploading ? (
//               <>
//                 <div className="flex justify-center items-center h-[200px]">
//                   <div className="w-24 h-24 border-8 border-gray-300 border-t-transparent rounded-full animate-spin"></div>
//                 </div>
//               </>
//             ) : (
//               AllTestimonial?.map((item, i) => (
//                 <div key={`testimonial-${i}`}>
//                   <div className='testimonials-box'>
//                     <div className='names-div'>
//                       <img className="w-20 h-20 rounded-full object-cover" src={item?.Image} />
//                       <div className='names'>
//                         <h3>{item?.Name}</h3>
//                         <h4>{item?.Adderss}</h4>
//                       </div>
//                     </div>
//                     <h2>{item?.Message}</h2>
//                     <br />
//                     <div className='starts'>
//                       {[...Array(item?.Rating)]?.map((_, j) => (
//                         <i key={j} className="bi bi-star-fill"></i>
//                       ))}
//                     </div>
//                   </div>
//                 </div>
//               )))}
//           </div>
//         </div>

//       </div>
//       {/* <div className='en-fund-div'>
//         <div className='en-fund en-fund-v2'>
//           <div className='en-fund-left'>
//             <h3>Emergency Fund</h3>
//             <p>Available to support homeowners in unforeseen situations lorg construction projects.</p>
//             <button className='v2-btn'>Get Now</button>
//           </div>
//           <div className='en-fund-right'>
//             <img src={en} />
//           </div>
//         </div>
//       </div> */}
//       <Footer />
//     </>
//   )
// }

// export default Home


import React, { useEffect, useRef, useState } from 'react';
import Navbar from '../Components/Navbar';
import icon from '../Assets/Button Icon Container.png';
import img2 from '../Assets/why.png';
import icon2 from '../Assets/icon (3).png';
import icon3 from '../Assets/icon (1).png';
import icon4 from '../Assets/icon (4).png';
import Footer from '../Components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useNavigate } from 'react-router-dom';
import back from '../Assets/Background.png';
import about from '../Assets/Group 39547.png';
import { apiGet } from '../API/Api_Url';
import arrow from '../Assets/arrow.png';
import labour from '../Assets/labour.png';
import service from '../Assets/seerv.png';
import Contractor from '../Assets/Contractor1.png'
import material from '../Assets/material.png'
import freelancer from '../Assets/freelancer.png'

function Home() {
  const navigate = useNavigate()
  const sectionRef = useRef(null);
  const count1 = useRef(null);
  const count2 = useRef(null);
  const count3 = useRef(null);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  const animateCount = (element, target) => {
    let start = 0;
    const duration = 1000;
    const increment = target / (duration / 20);

    const updateCount = () => {
      start += increment;
      if (start >= target) {
        start = target;
        element.innerText = Math.round(start);
        clearInterval(timer);
      } else {
        element.innerText = Math.round(start);
      }
    };

    const timer = setInterval(updateCount, 20);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          if (count1.current && count2.current && count3.current) {
            count1.current.innerText = '0';
            count2.current.innerText = '0';
            count3.current.innerText = '0';
            animateCount(count1.current, 90);
            animateCount(count2.current, 120);
            animateCount(count3.current, 25);
          }
        }
      },
      {
        threshold: 0.5,
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  const [IsLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("userToken");
    if (token) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const [AllTestimonial, setAllTestimonial] = useState([]);

  const [IsUploading, setIsUploading] = useState(false);

  const GetAllTestimonials = async () => {
    try {
      setIsUploading(true);
      const response = await apiGet('api/admin/GetAllTestimonials');
      setAllTestimonial(response?.data);
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.error('Error fetching data:', error);
    }
  }

  useEffect(() => {
    GetAllTestimonials()
  }, []);

  return (
    <>
      <Navbar />
      <div className='banner'>
        <div className='banner-text' data-aos-duration="2000" data-aos="fade-down">
          <h5>Building Dreams with the Right Professionals.</h5>
        </div>
        <h3 data-aos-duration="2000" data-aos="fade-down">Your Project Our Network</h3>
        <p data-aos-duration="2000" data-aos="fade-down">Post your construction requirements and get connected with our network of Professionals.</p>
        <div className='flex gap-8'>
          <button
            onClick={() => {
              if (!IsLoggedIn) {
                navigate('/ph-UserLogin');
              } else {
                navigate('/AddRequirement');
              }
            }} data-aos-duration="2000" data-aos="fade-down" className='banner-button'>Post Your Requirements <img src={icon} />
          </button>
          <button
            onClick={() => { navigate('/SelectProfessionalTypeSignUp') }} data-aos-duration="2000" data-aos="fade-down" className='banner-button'>Join As Professionals <img src={icon} />
          </button>
        </div>
      </div>
      <div className='about-us'>
        <div className='about-us-heading'>
          <p>About Us</p>
          <h3>Our Foundation is Built On <br /><span>Trust & Excellence.</span></h3>
        </div>
        <br />
        <br />
        <br />
        <div className='about-us-div'>
          <div className='about-us-div-left'>
            <h3>We Build Everything That
              You Needed</h3>
            <p>We build. From workplaces and hospitals to hotels and cultural to the
              centers, we build the amazing places  that define communities.</p>
            <ul>
              <li>World’s most admired companies for the  consecutive year.</li>
              <li>Modern method & certified company.</li>
              <li>Highlight the use of durable materials.</li>

            </ul>
            <br />
            <br />
            <img src={back} />
          </div>
          <div className='about-us-div-right'>
            <img src={about} />
          </div>
        </div>
      </div>
      <div className='whyus'>
        <div className='whyus-heading'>
          <div className='whyus-div'>
            <p>WHY CHOOSE US</p>
          </div>
          <h3>Our Services Make Us the Best <br />Construction Agency</h3>

        </div>
        <br />
        <br />
        <br />
        <div className='why-types'>
          <div className='why-types-left'>
            <div className='why-types-div'>
              <div className='ty-icon'>
                <img src={icon2} />

              </div>
              <h4>Broad Network</h4>
              <p>Transforming spaces with precision and creativity to enhance functionality and style.</p>
            </div>
            <br />
            <br />
            <div className='why-types-div'>
              <div className='ty-icon'>
                <img src={icon2} />

              </div>
              <h4>Reliable Service</h4>
              <p>Transforming spaces with precision and creativity to enhance functionality and style.</p>
            </div>
          </div>
          <div className='why-types-center'>
            <img src={img2} />
          </div>
          <div className='why-types-right'>
            <div className='why-types-div'>
              <div className='ty-icon'>
                <img src={icon3} />

              </div>
              <h4>Qualified Professionals</h4>
              <p>Transforming spaces with precision and creativity to enhance functionality and style.</p>
            </div>
            <br />
            <br />
            <div className='why-types-div'>
              <div className='ty-icon'>
                <img src={icon4} />

              </div>
              <h4>Certified Engineers</h4>
              <p>Transforming spaces with precision and creativity to enhance functionality and style.</p>
            </div>
          </div>
        </div>
      </div>
      <div className='howitworks'>
        <div className='howitworks-div'>
          <div className='whyus-heading'>
            <div className='whyus-div'>
              <p>PROCESS</p>
            </div>
            <h3>How Its Works</h3>
            <br />
            <br />
          </div>
          <div className='Post'>
            <div className='Post-div'>
              <h3>01</h3>
              <p>Post Your Project Requirements</p>
            </div>
            <div className='line'></div>
            <div className='Post-div'>
              <h3>02</h3>
              <p>Connect With Contractor & Suppliers</p>
            </div>
            <div className='line'></div>
            <div className='Post-div'>
              <h3>03</h3>
              <p>Complete Your Project With Ease</p>
            </div>
          </div>
        </div>
      </div>
      <div className='v2-service'>
        <div className='about-us-heading'>
          <p>Services</p>
          <h3>Services  <span>We Offer</span></h3>
        </div>
        <br />
        <br />
        <div className="service-scroll-wrapper">
          <div className="service-boxs">
            {[...Array(2)].map((_, i) => (
              <React.Fragment key={i}>
                <div>
                  <div className="service-box">
                    <img className="service-box-img" src={Contractor} />
                    <img className="arrow" src={arrow} />
                    <p>Contractors</p>
                  </div>
                </div>
                <div>
                  <div className="service-box">
                    <img className="service-box-img " src={material} />
                    <img className="arrow" src={arrow} />
                    <p>Material-Supplier</p>
                  </div>
                </div>
                <div>
                  <div className="service-box">
                    <img className="service-box-img" src={freelancer} />
                    <img className="arrow" src={arrow} />
                    <p>Freelance Engineers</p>
                  </div>
                </div>
                <div>
                  <div className="service-box">
                    <img className="service-box-img" src={labour} />
                    <img className="arrow" src={arrow} />
                    <p>Labours</p>
                  </div>
                </div>
                <div>
                  <div className="service-box">
                    <img className="service-box-img" src={material} />
                    <img className="arrow" src={arrow} />
                    <p>Architects & Consultants</p>
                  </div>
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
      <div className='testimonials'>
        <div className='whyus-heading'>
          <div className='whyus-div'>
            <p>How It Helps Simplify Your Construction</p>
          </div>
          <h3>What Over Client Says</h3>
          <br />
          <br />
        </div>
        <div className='testimonials-scroll-wrapper'>
          <div className='testimonials-boxs'>
            {IsUploading ? (
              <>
                <div className="flex justify-center items-center h-[200px]">
                  <div className="w-24 h-24 border-8 border-gray-300 border-t-transparent rounded-full animate-spin"></div>
                </div>
              </>
            ) : (
              AllTestimonial?.map((item, i) => (
                <div key={`testimonial-${i}`}>
                  <div className='testimonials-box'>
                    <div className='names-div'>
                      <img className="w-20 h-20 rounded-full object-cover" src={item?.Image} />
                      <div className='names'>
                        <h3>{item?.Name}</h3>
                        <h4>{item?.Adderss}</h4>
                      </div>
                    </div>
                    <h2>{item?.Message}</h2>
                    <br />
                    <div className='starts'>
                      {[...Array(item?.Rating)]?.map((_, j) => (
                        <i key={j} className="bi bi-star-fill"></i>
                      ))}
                    </div>
                  </div>
                </div>
              )))}
            {IsUploading ? (
              <>
                <div className="flex justify-center items-center h-[200px]">
                  <div className="w-24 h-24 border-8 border-gray-300 border-t-transparent rounded-full animate-spin"></div>
                </div>
              </>
            ) : (
              AllTestimonial?.map((item, i) => (
                <div key={`testimonial-${i}`}>
                  <div className='testimonials-box'>
                    <div className='names-div'>
                      <img className="w-20 h-20 rounded-full object-cover" src={item?.Image} />
                      <div className='names'>
                        <h3>{item?.Name}</h3>
                        <h4>{item?.Adderss}</h4>
                      </div>
                    </div>
                    <h2>{item?.Message}</h2>
                    <br />
                    <div className='starts'>
                      {[...Array(item?.Rating)]?.map((_, j) => (
                        <i key={j} className="bi bi-star-fill"></i>
                      ))}
                    </div>
                  </div>
                </div>
              )))}
          </div>
        </div>

      </div>
      <Footer />
    </>
  )
}

export default Home
